var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"7","height":"9","viewBox":"0 0 7 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M-8.76697e-05 7.96066L0.923434 8.74219L6.05469 4.37094L0.918247 -0.0003123L-8.70418e-05 0.781214L4.21802 4.37094L-8.76697e-05 7.96066Z","fill":"#8A2BE2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }